import api from '../Axios';

export const ledgerApi = {
  // Fetch filtered earnings for the expert ledger/dashboard
  getExpertEarnings: async (
    expertCode: string, 
    filter: string = '7days', 
    startDate?: string, 
    endDate?: string
  ) => {
    
    // Axios automatically constructs the ?filter=...&startDate=... URL
    const params: any = { filter };
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;

    // 🟢 FIXED: Added the /api prefix right here!
    const response = await api.get(`/api/experts/${expertCode}/earnings`, { params });
    
    return response.data;
  }
};